module.exports = __webpack_public_path__ + "img/box.7286ddc2.png";